import { Dictionary } from './../../classes/UtilityFunctions';

import { DisplayStateService } from './../../services/DisplayStateService';
import { Params } from '@angular/router';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild, TemplateRef } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';

import { Subject } from 'rxjs/Rx';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/takeUntil';

import { DataSetFilter, FilterSpec } from '../../classes/DataSetFilter';
import { DataSet } from '../../interfaces/DisplayInterfaces';
import { HeatmapRules } from '../../interfaces/WidgetInterfaces';

import {
  GenericTableConfiguration,
  NameValue,
  TableColumnRules,
  DataTableValueInfo,
  TableButtonInfo,
  TableRowSelectionButton
} from '../../interfaces/WidgetInterfaces';
import * as _ from 'lodash';

@Component({
  selector: 'app-platform-table',
  template: `<ng-template #filteringToolTip>

    <div class="modal-header">
        <h4 class="modal-title pull-left">Table tips</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="hideModal(tooltipModalRef)">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">

        <span class="font-weight-bold">Text Column Filtering:</span> Use the following patterns in the column filtering boxes for the example text 'abc'
        <ul class="list-group">
            <li class="list-group-item">
                <span class="font-weight-bold">abc</span> : value starts with 'abc'.
                <span class="font-weight-light">Same as abc*</span>
            </li>
            <li class="list-group-item">
                <span class="font-weight-bold">abc*</span> : value starts with 'abc'</li>
            <li class="list-group-item">
                <span class="font-weight-bold">*abc</span> : value ends with 'abc'</li>
            <li class="list-group-item">
                <span class="font-weight-bold">*abc*</span> : value in column contains 'abc'</li>
            <li class="list-group-item">
                <span class="font-weight-bold">=abc</span> : value in is 'abc'</li>
            <li class="list-group-item">
                <span class="font-weight-bold">!abc</span> : value in is not 'abc'</li>
        </ul>
        <span class="font-weight-bold">Numeric Column Filtering:</span> Use the following patterns in the column filtering boxes for the example value 100.
        <ul class="list-group">
            <li class="list-group-item">
                <span class="font-weight-bold">=100</span> : value is 100</li>
            <li class="list-group-item">
                <span class="font-weight-bold">!100</span> : value is not 100</li>
            <li class="list-group-item">
                <span class="font-weight-bold">&gt;100</span> : value is greater than 100</li>
            <li class="list-group-item">
                <span class="font-weight-bold">&gt;=100</span> : value is greater than or equal to 100</li>
            <li class="list-group-item">
                <span class="font-weight-bold">&lt;100</span> : value is less than 100</li>
            <li class="list-group-item">
                <span class="font-weight-bold">&lt;=100</span> : value is less than or equal to 100</li>
        </ul>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="hideModal(tooltipModalRef)">Close</button>
    </div>




</ng-template>

<div *ngIf="columns && columns.length > 0;  else loading" class="table">
    <table class="" [ngClass]="IsCustomTableClasses()">
        <tr *ngIf="!mergedConfig.hideHeaderRow">
            <td [attr.colspan]="TotalColumnCount()">
                <button type="button" (click)="ToggleFilterSortRow()" class="btn btn-sm">
                    <i class="fa fa-filter"></i>
                </button>
                <button *ngIf="HasLocalFilters()" type="button" (click)="ClearFilters()" class="btn btn-sm">
                    Clear filters
                </button>
                <button class="btn btn-sm case-sensitive" [class.btn-success]="isCaseSensitive" (click)="isCaseSensitive = !isCaseSensitive">
                    <span *ngIf="isCaseSensitive" title="Case Sensitive">case sensitive filtering</span>
                    <span *ngIf="!isCaseSensitive" title="Case Insensitive">case insensitive filtering</span>
                </button>

                <button *ngIf="IsExportToCsvEnabled()" type="button" (click)="ExportToCsv()" class="btn btn-sm">
                    <i class="fa fa-download"></i>
                    <span> Export to .csv</span>
                </button>
                <span class="label label-default" (click)="ShowTooltip()" placement="bottom" style="cursor: pointer">
                    <i class="fa fa-info-circle fa-lg"></i>
                </span>
                <span class="pull-right">
                    <span class="m-1">Global Filter:</span>
                    <input type="text" style="width: 80px" [ngModel]="filter" (ngModelChange)="onGlobalFilterChange($event)" placeholder="filter" />
                </span>
            </td>
        </tr>
        <tr>
            <th *ngIf="NeedsButtonColumn('start')">{{getButtonColumnLabel()}}</th>
            <th *ngFor="let column of columns; let colIdx = index" [hidden]="hideColumn(colIdx)">
                {{column}}
            </th>
            <th *ngIf="NeedsButtonColumn('end')">{{getButtonColumnLabel()}}</th>
        </tr>
        <tr *ngIf="filterRowVisible">
            <th *ngIf="NeedsButtonColumn('start')">...</th>
            <th style="min-width: 90px" *ngFor="let column of columns; let colIdx = index " [hidden]="hideColumn(colIdx)">
                <div class="input-group">
                    <input type="text" style="min-width: 50px" [ngModel]="filterlkp[column]" (ngModelChange)="onFilterChange(column, $event)"
                        placeholder="filter" />
                    <i class="fa-sort-amount-asc fa btn btn-sm btn-secondary" (click)="ToggleAndSort(column, $event)"></i>
                </div>
            </th>
            <th *ngIf="NeedsButtonColumn('end')">...</th>
        </tr>
        <tr *ngIf="dropdownRowVisible">
            <th *ngIf="NeedsButtonColumn('start')">...</th>
            <th style="min-width: 90px" *ngFor="let column of columns; let colIdx = index" [hidden]="hideColumn(colIdx)">
                <div class="input-group">
                    <select name="dropDownColumn" (change)="onDropdownChanged(column, $event.target.value)">
                        <option>(all)</option>
                        <option *ngFor="let s of dropdowns[colIdx]">{{s}}</option>
                    </select>
                    <i class="fa-sort-amount-asc fa btn btn-sm btn-secondary" (click)="ToggleAndSort(column, $event)"></i>
                </div>
            </th>
            <th *ngIf="NeedsButtonColumn('end')">...</th>
        </tr>
        <tr (mouseover)='ClientHover(rowIdx)' *ngFor="let row of PageOfRows(); let rowIdx = index" [ngClass]="{ 'table-success': activeRowIdx == rowIdx }">
            <td *ngIf="NeedsButtonColumn('start')" nowrap>
                <div *ngIf="Config && Config.buttonNames && Config.buttonNames.length > 0; else tryButtonInfo">
                    <button *ngFor="let button of Config.buttonNames" type="button" class="btn btn-sm btn-outline-primary" (click)="ClientButtonClick(button, rowIdx)">{{button}}</button>
                </div>
            </td>
            <ng-template #tryButtonInfo>
                <div *ngIf="Config && Config.buttonInfoList && Config.buttonInfoList.length > 0" nowrap>
                    <button *ngFor="let buttonInfo of Config.buttonInfoList" type="button" class="btn btn-xs btn-outline-primary" [ngClass]="getbuttonClassName(rowIdx, buttonInfo.name)"
                        (click)="ClientButtonInfoClick(buttonInfo, rowIdx)" [tooltip]="getbuttonToolTip(rowIdx, buttonInfo.name)"
                        [delay]="100">
                        {{getbuttonText(rowIdx, buttonInfo.name)}}
                        <i [ngClass]="getbuttonIconClassName(rowIdx, buttonInfo.name)"></i>
                    </button>
                </div>
            </ng-template>
            <td class="td-inner-color-div" *ngFor="let field of row; let colIdx = index" [align]="getColAlign(colIdx)" [hidden]="hideColumn(colIdx)">
                <div class="div-inner-td">
                    <div *ngIf="paretoColumns.indexOf(columns[colIdx]) > -1; else standardColumn;">
                        <div class="pareto-td-flex-row">
                            <div class="bg-dark p-10" class="pareto-svg">
                                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" class="chart " height="14px"
                                    role="img" [attr.width]="GetCellScaledValue(rowIdx, colIdx) + '%'">
                                    <g class="bar">
                                        <rect class="text-info" width="100%" height="100%" style="fill: currentColor;" />
                                    </g>
                                </svg>
                            </div>
                            <div class="pareto-value">
                                &nbsp; {{RoundDecimalValue(rowIdx, colIdx, 3)}}
                            </div>
                        </div>
                    </div>
                    <ng-template #standardColumn>
                        <div class="div-inner-td" [ngStyle]="{'background-color': GetBgColorStyle(rowIdx, colIdx), 'color': GetFgColorStyle(rowIdx, colIdx) }" [tooltip]="GetToolTip(rowIdx, colIdx)">
                            <a *ngIf="isValueClickLink(colIdx); else plainTd" (click)="onValueClick(colIdx, rowIdx, $event)" class="hover-pointer">
                                <span *ngIf="!GetIsHtml(rowIdx, colIdx); else renderHTML"> {{GetCellText(rowIdx, colIdx)}}</span>
                            </a>
                            <ng-template #plainTd>{{GetCellText(rowIdx, colIdx)}}</ng-template>
                            <ng-template #renderHTML>
                                <span [innerHTML]="GetCellText(rowIdx, colIdx)"></span>
                            </ng-template>
                        </div>

                    </ng-template>
                </div>
            </td>
            <td *ngIf="NeedsButtonColumn('end')" nowrap>
                <div *ngIf="Config && Config.buttonNames && Config.buttonNames.length > 0; else tryButtonInfo">
                    <button *ngFor="let button of Config.buttonNames" type="button" class="btn btn-sm btn-outline-primary" (click)="ClientButtonClick(button, rowIdx)">{{button}}</button>

                </div>
            </td>
        </tr>
        <tr class="table-info">
            <td [attr.colspan]="TotalColumnCount()">
                <button type="button" (click)="ToggleFilterSortRow()" class="btn btn-sm btn-primary">
                    <i class="fa fa-filter"></i>
                </button>
                <button (click)="PageCrement(-999999)" type="button" class="btn btn-sm btn-primary">
                    <i class="fa fa-angle-double-left" aria-hidden="true"></i>
                </button>
                <button (click)="PageCrement(-1)" type="button" class="btn btn-sm btn-primary">
                    <i class="fa fa-angle-left" aria-hidden="true"></i>
                </button> Page
                <input style="width: 25px" type="text" [ngModel]="currentPage" (ngModelChange)="OnPageNumberChange($event)" /> of {{maxPage}}

                <button (click)="PageCrement(1)" type="button" class="btn btn-sm btn-primary">
                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                </button>
                <button (click)="PageCrement(999999)" type="button" class="btn btn-sm btn-primary">
                    <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                </button> Records: {{currentRecordStart+1}} - {{currentRecordEnd+1}} of {{filterRows.length}}
                <span class="pull-right">
                    <span class="m-1">Page size:</span>
                    <input type="text" style="width: 50px" [ngModel]="PageSize()" (ngModelChange)="onPageSizeChange($event)" />
                </span>
            </td>
        </tr>
    </table>
</div>


<ng-template #loading>
    <i class="fa fa-spinner fa-spin"></i> Loading data...
</ng-template>`,
  styles: [`.table-condensed>tbody>tr>td,
.table-condensed>tbody>tr>th,
.table-condensed>tfoot>tr>td,
.table-condensed>tfoot>tr>th,
.table-condensed>thead>tr>td,
.table-condensed>thead>tr>th{
    padding:2px;
    font-size:12px
}

.div-inner-td{
    height:100%;
    width:100%;
}

.table-responsive{
    width:auto;
}

.pareto-td-flex-row{
    display:-webkit-box;
    display:-ms-flexbox;
    display:flex;
    -webkit-box-align:start;
        -ms-flex-align:start;
            align-items:flex-start;
    -ms-flex-wrap:nowrap;
        flex-wrap:nowrap;
    height:100%;
}

.pareto-svg{
    max-width:70%;
    border:solid 1px rgba(0, 0, 0, 0.1);
    height:16px;
}

.pareto-value{
    max-width:30%;
}

i.fa.fa-sort-amount-asc,
i.fa.fa-sort-amount-desc,
button.btn.btn-sm.case-sensitive{
    cursor:pointer;
}

.custom-table-style{
    width:auto !important;
    min-width:600px;
}

.hover-pointer:hover{
    cursor:pointer;
}`]
})
export class PlatformTableComponent implements OnInit, OnDestroy, OnChanges {

  @Output() RemoveFilter: EventEmitter<string> = new EventEmitter<string>();
  @Output() AddFilter: EventEmitter<NameValue> = new EventEmitter<NameValue>();
  @Output() NewSort: EventEmitter<NameValue> = new EventEmitter<NameValue>();
  @Output() ButtonClick: EventEmitter<TableRowSelectionButton> = new EventEmitter<TableRowSelectionButton>();
  @Output() ButtonInfoClick: EventEmitter<Params> = new EventEmitter<Params>();
  @Output() Hover: EventEmitter<Params> = new EventEmitter<Params>();
  @Output() ValueClick: EventEmitter<DataTableValueInfo> = new EventEmitter<DataTableValueInfo>();
  @Output() RowChangeableEvent: EventEmitter<any> = new EventEmitter<any>();

  @Input() Config: GenericTableConfiguration;
  @Input() Dataset: DataSet | null;
  @Input() SortAndfilterLocally = false;
  @Input() TableClasses = ["table-condensed", "table-hover", "table-nonfluid", "table-responsive", "custom-table-style"];


  @ViewChild('filteringToolTip') filteringToolTipTemplate: TemplateRef<any>;
  tooltipModalRef: BsModalRef;
  searchUpdated: Subject<NameValue> = new Subject<NameValue>();
  ngUnsubscribe: Subject<boolean> = new Subject();

  defaultPageSize = 20;
  currentPage = 0;
  currentRecordStart = 0;
  currentRecordEnd = 0;
  minPage = 0;
  maxPage = 0;
  activeRowIdx: number = -1;
  columns: string[] = [];
  rows: string[][] = [];
  filterRows: string[][] = [];
  filter = '';
  filterlkp: Params = [];
  dropdowns: string[][] = [];
  dataSetCells: CellInfo[][] = [];
  buttonListCells: ButtonCellInfo[][] = [];
  paretoColumns: string[] = [];
  isCaseSensitive: boolean = false;
  localFilters: Params = [];
  filterRowVisible = true;
  dropdownRowVisible = false;
  
  cachedAlignRules: Dictionary<number, string> = new Dictionary<number, string>();

  defaultConfig: GenericTableConfiguration =
    {
      sortAndfilterLocally: this.SortAndfilterLocally,
      showFilterSortRow: true,
      showColumnDropdowns: false,
      pageSize: 22,
      tableColumnRules: [],
      buttonConfig: {
        buttonColumnName: '',
        buttonPosition: 'start'
      },
      TableClasses: ['table', 'table-bordered', 'table-condensed', 'table-hover', 'table-nonfluid', 'table-responsive', 'custom-table-style']
    };

  mergedConfig: GenericTableConfiguration = this.defaultConfig;

  HasLocalFilters(): boolean {
    return this.localFilters && Object.keys(this.localFilters).length > 0;
  }

  MergeConfigs() {

    this.mergedConfig = this.Config ? _.merge(this.defaultConfig, this.Config) : this.defaultConfig;
    this.BuildDisplay();
  }

  constructor(private displayStateService: DisplayStateService) { }

  PageSize() {
    return this.mergedConfig.pageSize;
  }

  NeedsButtonColumn(place): boolean {
    let returnValue = this.HasButtons();
    if (returnValue) {
      returnValue = this.getButtonPosition(place);
    }
    return returnValue;
  }

  getButtonPosition(place): boolean {
    if (this.mergedConfig.buttonConfig && this.mergedConfig.buttonConfig.buttonPosition === place) {
      return true;
    }
    return false;
  }

  getButtonColumnLabel() {
    const config = this.mergedConfig;
    if (this.mergedConfig.buttonConfig && this.mergedConfig.buttonConfig.buttonColumnName) {
      return this.mergedConfig.buttonConfig.buttonColumnName;
    }
    return this.defaultConfig.buttonConfig.buttonColumnName;

  }
  IsExportToCsvEnabled(): boolean {
    return this.mergedConfig.showExportToCsv;
  }

  IsCustomTableClasses() {
    return this.mergedConfig.TableClasses;
  }

  HasButtons(): boolean {
    const cfg = this.mergedConfig;
    return (cfg.buttonNames && cfg.buttonNames.length > 0) || (cfg.buttonInfoList && cfg.buttonInfoList.length > 0);
  }

  TotalColumnCount(): number {
    let colCount = this.columns.length;
    if (this.HasButtons()) {
      colCount++;
    }
    return colCount;
  }

  ToggleFilterSortRow() {

    if (this.filterRowVisible) {
      this.filterRowVisible = false;
      this.dropdownRowVisible = this.mergedConfig.showColumnDropdowns;
    } else if (this.dropdownRowVisible) {
      this.dropdownRowVisible = false;
      this.filterRowVisible = false;
    } else {
      this.filterRowVisible = true;
      if (!this.filterRowVisible) {
        this.dropdownRowVisible = this.mergedConfig.showColumnDropdowns;
      }
    }
  }

  RefreshFromDataSet() {

    this.cachedAlignRules = new Dictionary<number, string>();

    if (this.Dataset && this.Dataset.columns && this.Dataset.columns.length > 0) {
      this.columns = this.Dataset.columns;
      this.rows = this.Dataset.data;
      this.minPage = 1;
      this.currentPage = 1;
      if (this.mergedConfig.sortAndfilterLocally) {
        this.ApplyFilterParams();
      } else {
        this.ApplyGlobalFilter();
      }
    } else {
      this.columns = [];
      this.rows = [];
      this.currentPage = 0;
      this.minPage = 0;
      this.maxPage = 0;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['Dataset']) {
      this.RefreshFromDataSet();
      this.fireRowChangeEvent();
    } 
    if (changes['Config']) {
      this.MergeConfigs();
    }
  }

  ngOnInit() {
    this.searchUpdated
      .debounceTime(380)
      .takeUntil(this.ngUnsubscribe)
      .subscribe(e => { this.filterUpdate(e) });

      this.MergeConfigs();

    this.filterRowVisible = this.mergedConfig.showFilterSortRow;
    this.dropdownRowVisible = this.filterRowVisible ? false : this.mergedConfig.showColumnDropdowns;
  }

  filterUpdate(filterNV: NameValue, forceOnEmpty = false) {
    if (filterNV.value === undefined || filterNV.value === '') {
      if (this.mergedConfig.sortAndfilterLocally) {
        this.LocalRemoveFilter(filterNV.name);
      } else {
        this.RemoveFilter.emit(filterNV.name);
      }
    } else {
      const formatted = FilterSpec.UserExpressionToFormattedCS(filterNV.value, this.isCaseSensitive);
      if (formatted.endsWith('|') && !forceOnEmpty) {
        // do nothing - user has entered first part of an expression but no value
      } else {
        if (this.mergedConfig.sortAndfilterLocally) {
          this.LocalAddFilter(filterNV.name, FilterSpec.UserExpressionToFormattedCS(filterNV.value, this.isCaseSensitive));
        } else {
          this.AddFilter.emit({ name: filterNV.name, value: FilterSpec.UserExpressionToFormattedCS(filterNV.value, this.isCaseSensitive) });
        }
      }
    }
  }

  ToggleAndSort(colName: string, e: any) {
    let targetClass = e.target.classList;
    const asc = 'fa-sort-amount-asc';
    const desc = 'fa-sort-amount-desc';
    const p: Params[] = [];
    let columnType = '';
    if (e.target.className.includes('fa') && this.mergedConfig.sortAndfilterLocally) {
      this.mergedConfig.tableColumnRules.forEach(rules => {
        if (rules.columnName === colName && rules.isDate) {
          columnType = 'Date';
        }
      });
      if (e.target.className.includes(asc)) {
        p[colName] = 'asc';
        DataSetFilter.SortDataSet(this.Dataset, p, [], columnType);
        this.RefreshFromDataSet();
        targetClass.replace(asc, desc)
      } else {
        p[colName] = 'desc';
        DataSetFilter.SortDataSet(this.Dataset, p, [], columnType);
        this.RefreshFromDataSet();
        targetClass.replace(desc, asc)
      }
    } else {
      if (e.target.className.includes(asc)) {
        this.NewSort.emit({ name: colName, value: 'asc' });
        targetClass = desc;
        targetClass.replace(asc, desc)
      } else {
        this.NewSort.emit({ name: colName, value: 'desc' });
        targetClass.replace(desc, asc)
      }
    }
  }

  ExportToCsv() {
    const exportCsvOptions = this.mergedConfig.csvExportOptions;
    const separator = exportCsvOptions && exportCsvOptions.separator ? exportCsvOptions.separator : ',';
    const filename = exportCsvOptions && exportCsvOptions.fileName ? exportCsvOptions.fileName : 'download';
    // TODO: Add this
    // const onlyExportVisibleColumns =
    // exportCsvOptions && exportCsvOptions.onlyExportVisibleColumns ? exportCsvOptions.onlyExportVisibleColumns : false;

    let csvContent = '';
    csvContent += this.columns.join(separator);
    csvContent += '\n';

    this.filterRows.forEach((infoArray, index) => {
      let dataString = infoArray.join(separator);
      csvContent += index < this.filterRows.length ? dataString + '\n' : dataString;
    });

    this.DownloadCsv(csvContent, filename + '.csv', 'text/csv;encoding:utf-8');
  }

  DownloadCsv(content, fileName, mimeType) {
    const a = document.createElement('a');
    mimeType = mimeType || 'application/octet-stream';

    if (navigator.msSaveBlob) { // IE10
      navigator.msSaveBlob(new Blob([content], {
        type: mimeType
      }), fileName);
    } else if (URL && 'download' in a) { // html5 A[download]
      a.href = URL.createObjectURL(new Blob([content], {
        type: mimeType
      }));
      a.setAttribute('download', fileName);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } else {
      location.href = 'data:application/octet-stream,' + encodeURIComponent(content);
    }
  }

  SetSort(colName: string, sortExpression: string) {

    if (this.mergedConfig.sortAndfilterLocally) {
      const p: Params = [];
      p[colName] = sortExpression;
      DataSetFilter.SortDataSet(this.Dataset, p, []);
      this.RefreshFromDataSet();
    } else {
      this.NewSort.emit({ name: colName, value: sortExpression });
    }
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next(true);
    this.ngUnsubscribe.complete();
  }

  private getColumnRule(col: string): TableColumnRules {
    let rule = this.mergedConfig.tableColumnRules.find(r => r.columnName === col);
    if (rule) { return rule; }
    rule = this.mergedConfig.tableColumnRules.find(r => r.columnName === '*');
    if (rule) { return rule; } else { return undefined; }
  }

  private rangeMap(inMin: number, inMax: number, outMin: number, outMax: number, inValue: number): number {
    return (inValue - inMin) * (outMax - outMin) / (inMax - inMin) + outMin;
  }

  private maxTextLength(columnName: string, colIdx: number, tempInfo: CellInfo[][], rule: TableColumnRules) {
    if (rule && rule.maxTextLength) {
      const maxTextLength = rule.maxTextLength < 0 ? 0 : rule.maxTextLength;
      for (let row = 0; row < this.filterRows.length; row++) {
        tempInfo[row][colIdx].text =
          tempInfo[row][colIdx].text.length > maxTextLength ?
            tempInfo[row][colIdx].text.substr(0, maxTextLength) + '...' :
            tempInfo[row][colIdx].text;
      }

    }
  }

  private rowChange(columnName: string, colIdx: number, tempInfo: CellInfo[][], rule: TableColumnRules) {

    let curColor: string = '';

    if (rule && rule.rowChangeBehavior) {
      let changeIndex = -1;
      for (let row = 0; row < this.filterRows.length; row++) {
        if (row === 0 || this.filterRows[row - 1][colIdx] !== this.filterRows[row][colIdx]) {
          changeIndex++;
          tempInfo[row][colIdx].isBreak = true;

          if (rule.rowChangeBehavior.colorStringPallete) {
            const remainder = changeIndex % (rule.rowChangeBehavior.colorStringPallete.length);
            curColor = rule.rowChangeBehavior.colorStringPallete[remainder];
            tempInfo[row][colIdx].backgroundColor = curColor;
            tempInfo[row][colIdx].color = 'black';
          } else if (rule.rowChangeBehavior.whiteGray) {
            curColor = curColor === '' || curColor === '#EEEEEE' ? '#FBFBFB' : '#EEEEEE';
            tempInfo[row][colIdx].backgroundColor = curColor;
            tempInfo[row][colIdx].color = 'black';
          } else if (rule.rowChangeBehavior.randomColor) {
            const r = Math.round(this.rangeMap(0, 1, 100, 255, Math.random())).toString(16);
            const g = Math.round(this.rangeMap(0, 1, 100, 255, Math.random())).toString(16);
            const b = Math.round(this.rangeMap(0, 1, 100, 255, Math.random())).toString(16);

            curColor = `#${r}${g}${b}`;
            tempInfo[row][colIdx].backgroundColor = curColor;
            tempInfo[row][colIdx].color = 'black';
          }
          if (rule.rowChangeBehavior.hideDuplicates) {
            tempInfo[row][colIdx].text = this.filterRows[row][colIdx];
          }
        } else {
          tempInfo[row][colIdx].text = rule.rowChangeBehavior.hideDuplicates ? '' : this.filterRows[row][colIdx];

          if (curColor.length > 0) {
            tempInfo[row][colIdx].backgroundColor = curColor;
            tempInfo[row][colIdx].color = 'black';
          }
        }
      }
    }
  }

  private dropdown(columnName: string, colIdx: number, tempInfo: CellInfo[][], rule: TableColumnRules) {
    if (this.mergedConfig.showColumnDropdowns) {
      if (rule && rule.showDropdown) {
        this.dropdowns.push(Array.from(new Set(this.filterRows.map(row => row[colIdx]))));
      } else {
        this.dropdowns.push([]);
      }
    }
  }

  private paretoMap(columnName: string, colIdx: number, tempInfo: CellInfo[][], rule: TableColumnRules) {
    if (rule && rule.showPareto) {
      this.paretoColumns.push(columnName);
      let min: number = undefined;
      let max: number = undefined;
      if (rule.paretoRules) {
        min = rule.paretoRules.min;
        max = rule.paretoRules.max;
      } else {
        min = this.filterRows.reduce<number>((p, c) => {
          return p > Number(c[colIdx]) ? Number(c[colIdx]) : p;
        }, Number.MAX_VALUE);

        max = this.filterRows.reduce<number>((p, c) => {
          return p < Number(c[colIdx]) ? Number(c[colIdx]) : p;
        }, Number.MIN_VALUE);
      }
      for (let row = 0; row < this.filterRows.length; row++) {
        tempInfo[row][colIdx].scaledValue = this.scaleParetoValueToPercentage(Number(tempInfo[row][colIdx].text), min, max);
      }
    }
  }

  private minMaxForHeatmap(heatmapRules: HeatmapRules, colIdx: number): minMaxReply {
    const columnsToInclude = [colIdx];
    if (heatmapRules.columnsToInclude && heatmapRules.columnsToInclude.length > 0) {
      heatmapRules.columnsToInclude.forEach(cName => {
        var otherCIdx = this.columns.indexOf(cName);
        if (otherCIdx > -1) {
          columnsToInclude.push(otherCIdx);
        }
      });
    }

    let min: number = undefined;
    let max: number = undefined;

    if (heatmapRules.low === 'min' || heatmapRules.high === 'min') {
      min = this.filterRows.reduce<number>((p, row) => {
        const localLow = columnsToInclude.reduce<number>((localP, cIdx) => {
          return localP > Number(row[cIdx]) ? Number(row[cIdx]) : localP
        }, p)
        return p > localLow ? localLow : p;
      }, Number.MAX_VALUE);
    } else {
      min = Number(heatmapRules.low);
    }
    if (heatmapRules.low === 'max' || heatmapRules.high === 'max') {
      max = this.filterRows.reduce<number>((p, row) => {

        const localHigh = columnsToInclude.reduce<number>((localP, cIdx) => {
          return localP < Number(row[cIdx]) ? Number(row[cIdx]) : localP
        }, p)
        return p < localHigh ? localHigh : p;
      }, Number.MIN_VALUE);
    } else {
      max = Number(heatmapRules.high);
    }

    const reverse = max < min || heatmapRules.low === 'max' || heatmapRules.high === 'min';
    const range = Math.abs(max - min);
    min = max < min ? max : min;
    max = min + range;
    return { min: min, max: max, range: range, reverse: reverse };
  }

  private redMap(columnName: string, colIdx: number, tempInfo: CellInfo[][], rule: TableColumnRules) {
    if (rule && rule.redmapRules !== undefined && rule.redmapRules.low && rule.redmapRules.high) {

      let reply = this.minMaxForHeatmap(rule.redmapRules, colIdx);
      for (let row = 0; row < this.filterRows.length; row++) {

        let rank = 0.0;
        var value = Number(this.filterRows[row][colIdx]);

        if (isNaN(value)) {
          tempInfo[row][colIdx].backgroundColor = `#ffffff`;
          tempInfo[row][colIdx].color = 'black';
        }
        else {
          if (reply.range !== 0) {
            rank = (value - reply.min) / reply.range;
          }

          rank = rank < 0 ? 0 : rank > 1 ? 1 : rank;
          let category = Math.round(rank * 7);  // betwen 0 and 16
          if (!reply.reverse) {
            category = 7 - category;
          }
          category += 7;
          const hex = category.toString(16);
          tempInfo[row][colIdx].backgroundColor = `#FF${hex}0${hex}0`;
          tempInfo[row][colIdx].color = 'black';
        }
      }
    }
  }

  private greenMap(columnName: string, colIdx: number, tempInfo: CellInfo[][], rule: TableColumnRules) {
    if (rule && rule.greenmapRules !== undefined && rule.greenmapRules.low && rule.greenmapRules.high) {

      let reply = this.minMaxForHeatmap(rule.greenmapRules, colIdx);
      for (let row = 0; row < this.filterRows.length; row++) {

        let rank = 0.0;
        var value = Number(this.filterRows[row][colIdx]);

        if (isNaN(value)) {
          tempInfo[row][colIdx].backgroundColor = `#FFFFFF`;
          tempInfo[row][colIdx].color = 'black';
        } else {
          if (reply.range !== 0) {
            rank = (Number(this.filterRows[row][colIdx]) - reply.min) / reply.range;
          }

          rank = rank < 0 ? 0 : rank > 1 ? 1 : rank;
          let category = Math.round(rank * 7);  // betwen 0 and 16
          if (!reply.reverse) {
            category = 7 - category;
          }
          category += 7;
          const hex = category.toString(16);
          tempInfo[row][colIdx].backgroundColor = `#${hex}0FF${hex}0`;
          tempInfo[row][colIdx].color = 'black';
        }

      }
    }
  }

  private heatmap(columnName: string, colIdx: number, tempInfo: CellInfo[][], rule: TableColumnRules) {
    if (rule && rule.heatmapRules !== undefined && rule.heatmapRules.low && rule.heatmapRules.high) {

      let reply = this.minMaxForHeatmap(rule.heatmapRules, colIdx);


      for (let row = 0; row < this.filterRows.length; row++) {

        let rank = 0.5;
        var value = Number(this.filterRows[row][colIdx]);

        if (isNaN(value)) {
          tempInfo[row][colIdx].backgroundColor = `#ffffff`;
          tempInfo[row][colIdx].color = 'black';
        } else {
          if (reply.range !== 0) {
            rank = (Number(this.filterRows[row][colIdx]) - reply.min) / reply.range;
          }
          rank = rank < 0 ? 0 : rank > 1 ? 1 : rank;
          let category = Math.round(rank * 15);  // betwen 0 and 16

          if (reply.reverse) {
            category = 15 - category;
          }

          if (category > 3 && category < 12) {
            tempInfo[row][colIdx].backgroundColor = `#FFFFFF`;
            tempInfo[row][colIdx].color = 'black';
          } else if (category <= 3) {
            category += 12;
            const hex = category.toString(16);

            tempInfo[row][colIdx].backgroundColor = `#${hex}0FF${hex}0`;
            tempInfo[row][colIdx].color = 'black';
          } else { // > 12
            category = 27 - category;
            const hex = category.toString(16);
            tempInfo[row][colIdx].backgroundColor = `#FF${hex}0${hex}0`;
            tempInfo[row][colIdx].color = 'black';
          }
        }
      }
    }
  }

  BuildDisplay() {
    this.dataSetCells = [];
    this.dropdowns = [];

    const tempCells: CellInfo[][] = this.filterRows.map(row => {
      return row.map(cell => {
        const nci = new CellInfo(); nci.text = cell; return nci;
      });
    });

    if (this.mergedConfig.tableColumnRules.length > 0 && this.columns && this.columns.length > 0) {

      this.Dataset.columns.forEach((columnName, colIdx) => {
        // Drop downs
        const rule = this.getColumnRule(columnName);
        if (rule && rule.alternateColorOnValueChange) {
          if (!rule.rowChangeBehavior) {
            rule.rowChangeBehavior = { whiteGray: true }
          }
        }

        if (rule) {
          this.dropdown(columnName, colIdx, tempCells, rule);
          this.heatmap(columnName, colIdx, tempCells, rule);
          this.greenMap(columnName, colIdx, tempCells, rule);
          this.redMap(columnName, colIdx, tempCells, rule);
          this.paretoMap(columnName, colIdx, tempCells, rule);
        }
        this.rowChange(columnName, colIdx, tempCells, rule);
        this.maxTextLength(columnName, colIdx, tempCells, rule);
      });
      // this.aggregateStats = this.aggregateStats.sort((a, b) => { return b.index - a.index; });
      this.dropdowns = this.dropdowns.map(colList => { return colList.sort((a, b) => a.localeCompare(b)) });
    }
    this.dataSetCells = [...tempCells];

    if (this.mergedConfig.buttonInfoList && this.mergedConfig.buttonInfoList.length > 0) {
      let buttonSingleRow = <ButtonCellInfo[]>[];
      const tempButtonCells = this.filterRows.map(data => {
        return this.mergedConfig.buttonInfoList.map(btn => {
          const btnList = new ButtonCellInfo(btn.name, btn.class, btn.iconClass, btn.text, btn.toolTip);
          return btnList;
        })
      });
      this.buttonListCells = [...tempButtonCells];
    }
    this.fireRowChangeEvent();
  }

  fireRowChangeEvent() {
    if (this.RowChangeableEvent.observers.length > 0) {
      this.RowChangeableEvent.emit();
    }
  }
  getbuttonClassName(rowIdx, name) {
    const currentBtn = this.buttonListCells[rowIdx].find(btn => btn.name === name);
    if (currentBtn) {
      return currentBtn.class;
    } else {
      return '';
    }
  }

  getbuttonIconClassName(rowIdx, name) {
    const currentBtn = this.buttonListCells[rowIdx].find(btn => btn.name === name);
    if (currentBtn) {
      return currentBtn.iconClass;
    } else {
      return 'd-none';
    }
  }

  getbuttonText(rowIdx, name) {
    const currentBtn = this.buttonListCells[rowIdx].find(btn => btn.name === name);
    if (currentBtn) {
      return currentBtn.text;
    } else {
      return '';
    }
  }

  getbuttonToolTip(rowIdx, name) {
    const currentBtn = this.buttonListCells[rowIdx].find(btn => btn.name === name);
    if (currentBtn) {
      return currentBtn.toolTip;
    } else {
      return '';
    }
  }


  scaleParetoValueToPercentage(initialValue: number, minVal: number, maxVal: number) {
    const lowerBound = 0;
    const upperBound = 100;
    const scaledValue = (((initialValue - minVal) * (upperBound - lowerBound)) / (maxVal - minVal)) + lowerBound;
    const scaledValuePercent = Math.round(scaledValue * upperBound) / upperBound;
    if (isNaN(scaledValuePercent)) {
      return 0;
    }
    return scaledValuePercent;
  }

  LocalRemoveFilter(name: string) {
    const tempFilters: Params = [];

    Object.keys(this.localFilters)
      .filter(k => k !== name)
      .forEach(k => {
        tempFilters[k] = this.localFilters[k];
      });

    this.localFilters = tempFilters;
    this.ApplyFilterParams();
  }

  LocalAddFilter(name: string, value: string) {
    this.localFilters[name] = value;
    this.ApplyFilterParams();
  }

  isValueClickLink(colIdx: number): boolean {
    if (this.mergedConfig.tableColumnRules) {
      const rule = this.getColumnRule(this.columns[colIdx]);
      if (rule && rule.valueLink) {
        return true;
      }
    }
    return false;
  }

  onValueClick(colIdx, rowIdx, event) {
    if (this.isValueClickLink(colIdx)) {
      const actualRowIdx = this.currentRecordStart + rowIdx;
      this.ValueClick.emit({
        colIdx: colIdx, column: this.columns[colIdx],
        rowIdx: actualRowIdx, value: this.rows[actualRowIdx][colIdx],
        row: this.rows[actualRowIdx],
        event: event
      });
    }
  }

  ClearFilters() {
    this.filter = '';
    this.localFilters = [];
    this.ApplyFilterParams();
  }

  ApplyFilterParams() {
    if (this.localFilters) {
      const dataSet = DataSetFilter.FilterDataSet(this.Dataset, [], [], this.localFilters);
      this.columns = dataSet.columns;
      this.rows = dataSet.data;
      this.filterlkp = [];
      Object.keys(this.localFilters).forEach(k => {
        const userExp = FilterSpec.FormattedExpressionToUser({ name: k, value: this.localFilters[k] });
        if (this.columns.indexOf(userExp.name) > -1) {
          this.filterlkp[userExp.name] = userExp.value;
        }
      });
    } else {
      this.columns = this.Dataset.columns;
      this.rows = this.Dataset.data;
    }

    this.ApplyGlobalFilter();
  }

  ApplyGlobalFilter() {
    if (this.rows) {
      if (this.filter) {

        const filters = this.filter.toLowerCase().split('|');
        this.filterRows = this.rows.filter(row => {
          let matchingCells = 0;
          filters.forEach(filter => {
            const cellMatchIdx = row.findIndex(cell => cell.toLowerCase().indexOf(filter) > -1);
            if (cellMatchIdx > -1) {
              matchingCells++;
            }
          });

          return matchingCells === filters.length;
        });
      } else {
        this.filterRows = this.rows;
      }
    }
    this.CalculateMaxPage();
    this.BuildDisplay();
  }

  CalculateMaxPage() {
    this.maxPage = this.filterRows ? Math.ceil(this.filterRows.length / this.PageSize()) : 0;
  }

  ClientButtonInfoClick(tableButtonInfo: TableButtonInfo, rowidx) {
    this.activeRowIdx = rowidx;
    if (this.ButtonInfoClick) {
      const p: Params = [];
      p['buttonInfo'] = tableButtonInfo;
      p['row'] = this.filterRows[this.currentRecordStart + rowidx];
      p['column'] = this.columns;
      this.ButtonInfoClick.emit(p);
    }
  }

  ClientHover(rowidx) {
    if (this.Hover) {
      const p: Params = [];
      p['row'] = this.filterRows[this.currentRecordStart + rowidx];
      p['column'] = this.columns;
      this.Hover.emit(p);
    }
  }

  ClientButtonClick(button, rowidx) {
    this.activeRowIdx = rowidx;
    if (this.ButtonClick) {
      const p: TableRowSelectionButton = {
        buttonName: button,
        row: this.filterRows[this.currentRecordStart + rowidx],
        column: this.columns
      };
      this.ButtonClick.emit(p);
    }
  }

  GetBgColorStyle(row: number, col: number): string {

    row += this.currentRecordStart;
    if (this.DataSetHasCells(row, col) && this.dataSetCells[row][col].backgroundColor) {
      // console.log('.');
      return this.dataSetCells[row][col].backgroundColor
    } else {
      // console.log('!');
      return '';
    }
  }

  getColAlign(col: number): string {
    if (!this.cachedAlignRules.containsKey(col)) {
      const rule = this.getColumnRule(this.columns[col]);
      this.cachedAlignRules[col] = rule && rule.textAlign ? rule.textAlign : 'left';
    }
    return this.cachedAlignRules[col];
  }

  GetCellText(row: number, col: number): string {
    row += this.currentRecordStart;
    if (this.DataSetHasCells(row, col)) {
      return this.dataSetCells[row][col].text
    } else {
      return '';
    }
  }

  private DataSetHasCells(row: number, col: number): boolean {
    const hasCells = this.dataSetCells.length !== 0 &&
      this.dataSetCells[row] !== undefined &&
      this.dataSetCells[row][col] !== undefined;

    if (!hasCells) {
      // console.log(`DataSetHasCells: returning false. row = ${row}, col = ${col}, dataset cells: ${this.dataSetCells}`);
    }
    return hasCells;



  }

  RoundDecimalValue(row: number, col: number, precision: number): string {
    row += this.currentRecordStart;
    if (this.DataSetHasCells(row, col)) {
      const cellValue = this.dataSetCells[row][col].text;
      if (isNaN(Number(cellValue))) {
        return this.dataSetCells[row][col].text;
      }
      if (precision < 0) {
        precision = 0;
      }
      return parseFloat(cellValue).toFixed(precision);
    } else {
      return '';
    }
  }

  GetCellScaledValue(row: number, col: number): number {
    row += this.currentRecordStart;
    if (this.DataSetHasCells(row, col)) {
      const scaledValue = this.dataSetCells[row][col].scaledValue;
      if (isNaN(scaledValue)) {
        return 0;
      }
      return scaledValue;
    } else {
      return 0;
    }
  }

  GetFgColorStyle(row: number, col: number): string {

    row += this.currentRecordStart;
    if (this.DataSetHasCells(row, col) && this.dataSetCells[row][col].color) {
      // console.log('.');
      return this.dataSetCells[row][col].color
    } else {
      // console.log('!');
      return '';
    }
  }

  onGlobalFilterChange(newValue: string) {
    this.filter = newValue;
    this.ApplyGlobalFilter();
  }

  onFilterChange(column, filterExpression) {
    this.searchUpdated.next({ name: column, value: filterExpression });
  }

  onDropdownChanged(column, filterExpression) {
    const filterValue = filterExpression === '(all)' ? '' : `=${filterExpression}`;

    this.filterUpdate({ name: column, value: filterValue }, true);
  }

  PageCrement(amount: number) {
    if (this.columns) {
      this.activeRowIdx = -1;
      this.currentPage += amount;
      if (this.currentPage < 1) {
        this.currentPage = 1;
      } else if (this.currentPage > this.maxPage) {
        this.currentPage = this.maxPage;
      }
    }
  }

  onPageSizeChange(newValue: string) {

    if (this.Config && this.Config.pageSize) {
      this.Config.pageSize = Number(newValue);
    } else {
      this.defaultConfig.pageSize = Number(newValue);
    }

    this.CalculateMaxPage();
    if (this.currentPage > this.maxPage) {
      this.currentPage = this.maxPage;
    }
  }

  OnPageNumberChange(newValue: string) {

    let num = Number(newValue);
    if (num > this.maxPage) {
      num = this.maxPage;
    }
    if (num < 1) {
      num = 1;
    }

    this.currentPage = num;
  }

  PageOfRows(): string[][] {
    if (this.filterRows && this.filterRows.length > 0) { }
    const lastIndex = this.filterRows.length - 1;
    if (lastIndex < this.PageSize()) {
      this.currentRecordStart = 0;
      this.currentRecordEnd = lastIndex;
      return this.filterRows;
    } else {

      this.currentRecordStart = (this.currentPage - 1) * this.PageSize();
      this.currentRecordEnd = this.currentRecordStart + this.PageSize() - 1;

      if (this.currentRecordStart > lastIndex) {
        this.currentRecordStart = lastIndex - this.PageSize();
      }

      if (this.currentRecordEnd > lastIndex) {
        this.currentRecordEnd = lastIndex;
      }
      return this.filterRows.slice(this.currentRecordStart, this.currentRecordEnd);
    }
  }

  ShowTooltip() {
    this.tooltipModalRef = this.displayStateService.OpenModal(this.filteringToolTipTemplate, 'modal-md');
  }

  hideModal(elemRef) {
    this.displayStateService.HideModal(elemRef);
    elemRef = undefined;
  }

  hideColumn(colindx) {
    if (colindx !== undefined && colindx > -1) {
      const colRule = this.getColumnRule(this.columns[colindx]);
      if (colRule && colRule.hideColumn) {
        return colRule.hideColumn;
      }
    }
    return false;

  }
  GetIsHtml(row: number, col: number): boolean {
    row += this.currentRecordStart;
    if (this.DataSetHasCells(row, col) && this.dataSetCells[row][col].isHTML) {
      return this.dataSetCells[row][col].isHTML
    } else {
      return false;
    }
  }

  GetToolTip(row: number, col: number): string {
    row += this.currentRecordStart;
    if (this.DataSetHasCells(row, col)) {
      return this.dataSetCells[row][col].tooltip;
    } else {
      return '';
    }
  }
}

export class CellInfo {
  backgroundColor: string;
  color: string;
  text: string;
  isBreak: boolean;
  scaledValue: number; // Used for the pareto columns
  isHTML: boolean;
  tooltip: string;
  constructor() {
    this.backgroundColor = '';
    this.color = '';
    this.isBreak = false;
    this.text = '';
    this.scaledValue = undefined; // Used for the pareto columns
    this.isHTML = false;
    this.tooltip = '';
  }
}

export class ButtonCellInfo {
  name: string;
  class: string;
  iconClass: string;
  text: string;
  toolTip: string
  constructor(name, className = '', iconClass = '', text = '', tooltip = '') {
    this.name = name;
    this.class = className;
    this.iconClass = iconClass;
    this.text = text;
    this.toolTip = tooltip;
  }
}

export class minMaxReply {
  min: number;
  max: number;
  range: number;
  reverse: boolean;
}
